const REGION_SEGMENTS = { EU: null, US: 'us' };

const certifierUrlForRegion = (region, certifierRoot) => {
    const segment = REGION_SEGMENTS[region];
    const url = new URL(certifierRoot);
    const [service, ...rest] = url.hostname.split('.');
    if (rest.length === 0) return certifierRoot;
    const segments = Object.values(REGION_SEGMENTS).filter(Boolean);
    const baseRest = rest.filter((p) => !segments.includes(p));
    const hostname = segment ? `${service}.${segment}.${baseRest.join('.')}` : `${service}.${baseRest.join('.')}`;
    return `${url.protocol}//${hostname}`;
};

export const getLoginUrl = (certifierRoot) => {
    const match = document.cookie.match(/(?:^|;\s*)pok_region=([^;]+)/);
    const region = match?.[1];
    return region ? certifierUrlForRegion(region, certifierRoot) : `${certifierRoot}/region-selector`;
};
